<script lang="ts">
  import clsx from 'clsx';

  const { sizeClass = 'h-full w-full' }: { sizeClass?: string } = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 70 74"
  fill="currentColor"
  class={clsx(sizeClass, 'overflow-hidden align-middle')}
  transform="rotate(90)"
>
  <path
    d="M31.7343 23.8777L31.7343 46.2559L56.9936 46.2559L45.8872 23.8777L31.7343 23.8777Z"
    fill="#6E7071"
    stroke="#979797"
  />
  <path
    d="M57.8 46.2564C60.8887 46.2564 63.8074 43.8476 65.9835 39.6777C68.1469 35.532 69.5 29.7701 69.5 23.3782C69.5 16.9863 68.1469 11.2244 65.9835 7.07864C63.8074 2.90875 60.8887 0.499999 57.7999 0.499999C54.7112 0.5 51.7925 2.90875 49.6164 7.07864C47.453 11.2244 46.0999 16.9863 46.0999 23.3782C46.0999 29.7701 47.453 35.532 49.6165 39.6777C51.7925 43.8476 54.7112 46.2564 57.8 46.2564Z"
    fill="#B2B4B4"
    stroke="#979797"
  />
  <path
    d="M57.8001 30.3722C58.525 30.3722 59.32 29.7619 59.9635 28.4563C60.5914 27.1827 60.9939 25.3881 60.9939 23.3787C60.9939 21.3692 60.5914 19.5746 59.9635 18.301C59.32 16.9954 58.525 16.3851 57.8001 16.3851C57.0753 16.3851 56.2803 16.9954 55.6367 18.301C55.0089 19.5746 54.6063 21.3692 54.6063 23.3787C54.6063 25.3881 55.0089 27.1827 55.6367 28.4563C56.2803 29.7619 57.0753 30.3722 57.8001 30.3722Z"
    fill="#6E7071"
    stroke="#979797"
  />
  <path
    d="M0.578035 23.3336L0.578045 23.3337L0.580025 23.3559L0.580025 23.3782L0.580027 73.156L45.6955 73.156L45.6955 23.3782C45.6955 13.7761 48.6339 7.81648 51.6142 4.25013C53.1009 2.471 54.5906 1.2964 55.7141 0.564511C55.7477 0.542612 55.781 0.521109 55.8139 0.499998L9.56792 0.5C4.37637 3.23836 2.10387 8.84541 1.14715 13.9009C0.667816 16.4338 0.525415 18.796 0.503258 20.5263C0.492189 21.3908 0.511151 22.0957 0.532767 22.5832C0.543573 22.827 0.555036 23.0162 0.563727 23.1437C0.568072 23.2075 0.571724 23.2558 0.574251 23.2877L0.577147 23.3233L0.577862 23.3316L0.578019 23.3334L0.578035 23.3336Z"
    fill="white"
    stroke="#979797"
  />
  <circle cx="22.5" cy="53.5" r="14.25" fill="white" stroke="#979797" stroke-width="0.5" />
  <circle cx="22.5" cy="20.5" r="14.25" fill="white" stroke="#979797" stroke-width="0.5" />
  <path
    d="M28.9999 49.2613L25.9759 50.4613V56.5093L28.9999 57.7333V61.5733L12.9919 55.1173V51.7333L28.9999 45.4213V49.2613ZM23.1439 55.4293V51.4693L17.7679 53.4373L23.1439 55.4293Z"
    fill="#757575"
  />
  <path
    d="M28.9999 16.2613L25.9759 17.4613V23.5093L28.9999 24.7333V28.5733L12.9919 22.1173V18.7333L28.9999 12.4213V16.2613ZM23.1439 22.4293V18.4693L17.7679 20.4373L23.1439 22.4293Z"
    fill="#757575"
  />
</svg>
